import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { Platform } from '@angular/cdk/platform';
import { TranslateService } from '@ngx-translate/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { FuseConfigService } from '@fuse/services/config.service';
import { FuseNavigationService } from '@fuse/components/navigation/navigation.service';
import { FuseSidebarService } from '@fuse/components/sidebar/sidebar.service';
import { FuseSplashScreenService } from '@fuse/services/splash-screen.service';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { navigation, navigation2,navigationteammember,paymentNavigation,paymentNavigation2,
         paymentNavigation3 } from 'app/navigation/navigation';
import { locale as navigationEnglish } from 'app/navigation/i18n/en';
import { locale as navigationTurkish } from 'app/navigation/i18n/tr';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { LoginService } from 'app/services/login.service';

@Component({
    selector: 'app',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, OnDestroy {
    fuseConfig: any;
    navigation: any;
    userTypee: any;
    isTeamMember:string;
    // Private
    private _unsubscribeAll: Subject<any>;

    /**
     * Constructor
     *
     * @param {DOCUMENT} document
     * @param {FuseConfigService} _fuseConfigService
     * @param {FuseNavigationService} _fuseNavigationService
     * @param {FuseSidebarService} _fuseSidebarService
     * @param {FuseSplashScreenService} _fuseSplashScreenService
     * @param {FuseTranslationLoaderService} _fuseTranslationLoaderService
     * @param {Platform} _platform
     * @param {TranslateService} _translateService
     */
    constructor(
        @Inject(DOCUMENT) private document: any,
        private _fuseConfigService: FuseConfigService,
        private _fuseNavigationService: FuseNavigationService,
        private _fuseSidebarService: FuseSidebarService,
        private _fuseSplashScreenService: FuseSplashScreenService,
        private _fuseTranslationLoaderService: FuseTranslationLoaderService,
        private _translateService: TranslateService,
        private _platform: Platform,
        private loginService : LoginService,
        private ngxService: NgxUiLoaderService
    ) {
        // this.userTypee = localStorage.getItem('userTypeId');
        // this.isTeamMember = localStorage.getItem('isTeammemberLogin');
        // let isProfile = localStorage.getItem('subActive');
        var cSession =   JSON.parse(localStorage.getItem('c_session'));
        // this.userTypee = cSession['userType'].userTypeId;
        this.userTypee = localStorage.getItem('userTypeId');
        // alert('this is user typee' + this.userTypee)
        this.isTeamMember = localStorage.getItem('c_isTeammemberLogin');
        let isProfile = localStorage.getItem('subActive');
        // let isProfile = cSession['subActive'];
      
        // Get default navigation
        if(isProfile == '1'){
            this._fuseNavigationService.unregister('admin-nav');
            this._fuseNavigationService.unregister('main');
            this._fuseNavigationService.unregister('team');
            this._fuseNavigationService.unregister('free');
            this._fuseNavigationService.unregister('freeCompany');
            this._fuseNavigationService.unregister('freeVendor');
    
            if (this.userTypee == '1') {
                this._fuseNavigationService.register('freeCompany', paymentNavigation3);
                this._fuseNavigationService.setCurrentNavigation('freeCompany');
            } else if(this.userTypee == '2'){
                this._fuseNavigationService.register('freeVendor', paymentNavigation2);
                this._fuseNavigationService.setCurrentNavigation('freeVendor');
            } else if(this.userTypee == '3'){
                this._fuseNavigationService.register('free', paymentNavigation);
                this._fuseNavigationService.setCurrentNavigation('free');
            }

        } else {
        if (this.userTypee == '3') {
            this._fuseNavigationService.unregister('admin-nav');
            this._fuseNavigationService.unregister('team');
            this._fuseNavigationService.unregister('main');
            this.navigation = navigation2;
            this._fuseNavigationService.register('admin-nav', this.navigation);
            this._fuseNavigationService.setCurrentNavigation('admin-nav');
          //  this.setNotificationCount();
          this.getMailCount();
          this.getVendorMailCount();

        } else if (this.userTypee == '1' || this.userTypee == '2') {
            if(this.isTeamMember == "true"){
                this._fuseNavigationService.unregister('admin-nav');
                this._fuseNavigationService.unregister('team');
                this._fuseNavigationService.unregister('main');
                this.navigation = navigationteammember;
                this._fuseNavigationService.register('team', this.navigation);
                this._fuseNavigationService.setCurrentNavigation('team');
               // this.setNotificationCount();
               this.getMailCount();
               this.getVendorMailCount();
            } else {
                this._fuseNavigationService.unregister('admin-nav');
                this._fuseNavigationService.unregister('main');
                this._fuseNavigationService.unregister('team');
             this.navigation = navigation;
             this._fuseNavigationService.register('main', this.navigation);
             this._fuseNavigationService.setCurrentNavigation('main');
           //  this.setNotificationCount();
           this.getMailCount();
           this.getVendorMailCount();
            }
        } 
    }
        
      /*  this.navigation = navigation;
        // Register the navigation to the service
        this._fuseNavigationService.register('main', this.navigation);
        // Set the main navigation as our current navigation
        this._fuseNavigationService.setCurrentNavigation('main'); 
        */

        // Add languages
        this._translateService.addLangs(['en', 'tr']);

        // Set the default language
        this._translateService.setDefaultLang('en');

        // Set the navigation translations
        this._fuseTranslationLoaderService.loadTranslations(navigationEnglish, navigationTurkish);

        // Use a language
        this._translateService.use('en');
        
        /**
         * ----------------------------------------------------------------------------------------------------
         * ngxTranslate Fix Start
         * ----------------------------------------------------------------------------------------------------
         */

        /**
         * If you are using a language other than the default one, i.e. Turkish in this case,
         * you may encounter an issue where some of the components are not actually being
         * translated when your app first initialized.
         *
         * This is related to ngxTranslate module and below there is a temporary fix while we
         * are moving the multi language implementation over to the Angular's core language
         * service.
         **/

        // Set the default language to 'en' and then back to 'tr'.
        // '.use' cannot be used here as ngxTranslate won't switch to a language that's already
        // been selected and there is no way to force it, so we overcome the issue by switching
        // the default language back and forth.
        /**
         setTimeout(() => {
            this._translateService.setDefaultLang('en');
            this._translateService.setDefaultLang('tr');
         });
         */

        /**
         * ----------------------------------------------------------------------------------------------------
         * ngxTranslate Fix End
         * ----------------------------------------------------------------------------------------------------
         */

        
        // Add is-mobile class to the body if the platform is mobile
        if (this._platform.ANDROID || this._platform.IOS) {
            this.document.body.classList.add('is-mobile');
        }

        // Set the private defaults
        this._unsubscribeAll = new Subject();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit(): void {
        if (this.userTypee == '1') {
            this.companyModuleHide();
        } else  if (this.userTypee == '2') {
            this.vendorModuleHide();
        } else  if (this.userTypee == '3') {
        }

        // Subscribe to config changes
        this._fuseConfigService.config
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((config) => {
                this.fuseConfig = config;
                // Boxed
                if (this.fuseConfig.layout.width === 'boxed') {
                    this.document.body.classList.add('boxed');
                }
                else {
                    this.document.body.classList.remove('boxed');
                }
                // Color theme - Use normal for loop for IE11 compatibility
                for (let i = 0; i < this.document.body.classList.length; i++) {
                    const className = this.document.body.classList[i];
                    if (className.startsWith('theme-')) {
                        this.document.body.classList.remove(className);
                    }
                }
                this.document.body.classList.add(this.fuseConfig.colorTheme);
            });
    }

    /**
     * On destroy
     */
    ngOnDestroy(): void {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Toggle sidebar open
     *
     * @param key
     */
    toggleSidebarOpen(key): void {
        this._fuseSidebarService.getSidebar(key).toggleOpen();
    }

    companyModuleHide() {
        this._fuseNavigationService.updateNavigationItem('vnDashboard', {
            hidden: true
        });
        this._fuseNavigationService.updateNavigationItem('vnMail', {
            hidden: true
        });
        this._fuseNavigationService.updateNavigationItem('vnProjects', {
            hidden: true
        });
        this._fuseNavigationService.updateNavigationItem('vnProjects', {
            hidden: true
        });
        this._fuseNavigationService.updateNavigationItem('vnProfile', {
            hidden: true
        });
        this._fuseNavigationService.updateNavigationItem('vnProposalsRequested', {
            hidden: true
        });
        this._fuseNavigationService.updateNavigationItem('vnSector Intelligence', {
            hidden: true
        });
        this._fuseNavigationService.updateNavigationItem('vnFeedback', {
            hidden: true
        });
        this._fuseNavigationService.updateNavigationItem('vnDocument Repository', {
            hidden: true
        });
        this._fuseNavigationService.updateNavigationItem('vnEquipment', {
            hidden: true
        });
        this._fuseNavigationService.updateNavigationItem('vnSetting', {
            hidden: true
        });

        this._fuseNavigationService.updateNavigationItem('teamMembers', {
            hidden: false
        });

        this._fuseNavigationService.updateNavigationItem('cmDashboard', {
            hidden: false
        });
        this._fuseNavigationService.updateNavigationItem('cmProjects', {
            hidden: false
        });
        this._fuseNavigationService.updateNavigationItem('cmProfile', {
            hidden: false
        });
        this._fuseNavigationService.updateNavigationItem('cmVendors', {
            hidden: false
        });
        this._fuseNavigationService.updateNavigationItem('cmRequestProposalSide', {
            hidden: false
        });
        this._fuseNavigationService.updateNavigationItem('cmTeam Members', {
            hidden: false
        });
        this._fuseNavigationService.updateNavigationItem('cmSector Intelligence', {
            hidden: false
        });
        this._fuseNavigationService.updateNavigationItem('cmFeedback', {
            hidden: false
        });
        this._fuseNavigationService.updateNavigationItem('cmDocument Repository', {
            hidden: false
        });
        this._fuseNavigationService.updateNavigationItem('cmEquipment', {
            hidden: false
        });
        this._fuseNavigationService.updateNavigationItem('cmequipments', {
            hidden: false
        });
        this._fuseNavigationService.updateNavigationItem('cmRates', {
            hidden: false
        });
    }

    vendorModuleHide() {
        this._fuseNavigationService.updateNavigationItem('cmDashboard', {
            hidden: true
        });
        this._fuseNavigationService.updateNavigationItem('cmProjects', {
            hidden: true
        });
        this._fuseNavigationService.updateNavigationItem('cmProfile', {
            hidden: true
        });
        this._fuseNavigationService.updateNavigationItem('cmVendors', {
            hidden: true
        });
        this._fuseNavigationService.updateNavigationItem('cmRequestProposalSide', {
            hidden: true
        });
        this._fuseNavigationService.updateNavigationItem('cmTeam Members', {
            hidden: true
        });
        this._fuseNavigationService.updateNavigationItem('teamMembers', {
            hidden: true
        });
        this._fuseNavigationService.updateNavigationItem('cmSector Intelligence', {
            hidden: true
        });

        this._fuseNavigationService.updateNavigationItem('cmDocument Repository', {
            hidden: true
        });
        this._fuseNavigationService.updateNavigationItem('cmEquipment', {
            hidden: true
        });
        this._fuseNavigationService.updateNavigationItem('cmequipments', {
            hidden: true
        });
        this._fuseNavigationService.updateNavigationItem('cmRates', {
            hidden: true
        });

      /* set navigation with hidden false*/

        this._fuseNavigationService.updateNavigationItem('vnDashboard', {
            hidden: false
        });
        this._fuseNavigationService.updateNavigationItem('vnMail', {
            hidden: false
        });
        this._fuseNavigationService.updateNavigationItem('vnProjects', {
            hidden: false
        });
        this._fuseNavigationService.updateNavigationItem('vnProjects', {
            hidden: false
        });
        this._fuseNavigationService.updateNavigationItem('vnProfile', {
            hidden: false
        });
        this._fuseNavigationService.updateNavigationItem('vnProposalsRequested', {
            hidden: false
        });
        this._fuseNavigationService.updateNavigationItem('vnSector Intelligence', {
            hidden: false
        });
        this._fuseNavigationService.updateNavigationItem('vnFeedback', {
            hidden: false
        });
        this._fuseNavigationService.updateNavigationItem('vnDocument Repository', {
            hidden: false
        });
        this._fuseNavigationService.updateNavigationItem('vnEquipment', {
            hidden: false
        });
        this._fuseNavigationService.updateNavigationItem('vnSetting', {
            hidden: false
        });

    }


 bothLoginSection(){
    this._fuseNavigationService.updateNavigationItem('vnDashboard', {
        'title': 'Dashboard - Vendor',
     });
    this._fuseNavigationService.updateNavigationItem('cmDashboard', {
    'title': 'Dashboard - Company',
     });
     this._fuseNavigationService.updateNavigationItem('cmProfile', {
    'title': 'Profile - Company',
     });
     this._fuseNavigationService.updateNavigationItem('vnProfile', {
        'title': 'Profile - Vendor',
    });
    this._fuseNavigationService.updateNavigationItem('cmVendors', {
        'title': 'Vendors - Vendor',
    });
    this._fuseNavigationService.updateNavigationItem('cmProjects', {
        'title': 'Project - Company',
    });
    this._fuseNavigationService.updateNavigationItem('vnProjects', {
        'title': 'Project - Vendor',
    });
    this._fuseNavigationService.updateNavigationItem('cmRequestProposalSide', {
        'title': 'Request Proposal - Company',
    });
    this._fuseNavigationService.updateNavigationItem('vnProposalsRequested', {
        'title': 'Proposals Requested - Vendor',
    });
    this._fuseNavigationService.updateNavigationItem('cmSector Intelligence', {
        'title': 'Sector Intelligence - Company',
    });
    this._fuseNavigationService.updateNavigationItem('vnSector Intelligence', {
        'title': 'Sector Intelligence - Vendor',
    });
    this._fuseNavigationService.updateNavigationItem('cmRates', {
        'title': 'Rates - Company',
    });
    this._fuseNavigationService.updateNavigationItem('vnFeedback', {
        'title': 'Rates - Vendor',
    });
 }

/*
setNotificationCount(){
        this._fuseNavigationService.updateNavigationItem('cmTeam Members', {
            'title': 'Mail',
            'badge': {
                'title': 4,
                'bg'   : 'rgb(3, 155, 228)',
                'fg'   : '#FFFFFF'
            } 
        }); 
        this._fuseNavigationService.updateNavigationItem('vnMail', {
            'title': 'Mail',
            'badge': {
                'title': 3,
                'bg'   : 'rgb(3, 155, 228)',
                'fg'   : '#FFFFFF'
            } 
        }); 
  }
*/
getMailCount(){
    this.loginService.getPendingMailCount(this._fuseNavigationService);
}

 getVendorMailCount(){
        this.loginService.getPendingVendorMailCount(this._fuseNavigationService);
    }


}
